import { makeNumberSchema, makeStrictNumberSchema } from '../general/number.ts';

const MIN = 1_200;
const MAX = 10_000;

const minMessage = `MTU must be at least ${MIN.toLocaleString()}`;
const maxMessage = `MTU can be at most ${MAX.toLocaleString()}`;
const requiredMessage = `Choose a number from ${MIN.toLocaleString()} to ${MAX.toLocaleString()}`;

export const tunMTUSchema = makeNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
});

export const tunMTURequiredSchema = tunMTUSchema.refine((val) => val !== null, {
  message: requiredMessage,
});

export const tunMTUStrictSchema = makeStrictNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
  required: { message: requiredMessage },
});
